// extracted by mini-css-extract-plugin
export var dataCell = "_qw-2";
export var dataRow = "_qw-0";
export var headerRow = "_qw-1";